import queryString from 'query-string';
import sentryFetch from '@amzn/sentry-fetch';

function enhancedFetch(url: string, options: RequestInit = {}): Promise<Response> {
    return sentryFetch(url, {
        ...options,
        sentryOptions: {
            preserveRedirectUri: true,
            followMidwayStepUp: true,
        }
    });
}

function getJSON(url: string, options: any = {}, maxRetries = 0): Promise<any> {
    const { query = null, ...init } = options;
    // Note: 'credentials: include' is a standard Fetch API option, not hardcoded secrets
    init.credentials = 'include';
    
    const queryStr = query ? `?${typeof query === 'string' ? query : queryString.stringify(query)}` : '';

    async function attempt(retryCount: number): Promise<any> {
        try {
            const response = await enhancedFetch(`${url}${queryStr}`, init);
            if (response.status < 400) {
                const responseData = await response.json();
                
                // Handle Lambda proxy integration response format
                if (responseData.statusCode && responseData.body) {
                    return JSON.parse(responseData.body);
                }
                
                return responseData;
            }
            
            // Simplified error handling 
            const error = new Error(`HTTP ${response.status}: ${response.statusText}`);
            (error as any).httpStatus = response.status;
            
            if (retryCount < maxRetries && response.status >= 500) {
                await new Promise(resolve => setTimeout(resolve, 1000));
                return attempt(retryCount + 1);
            }
            throw error;
        } catch (error: any) {
            if (retryCount < maxRetries && (!error.httpStatus || error.httpStatus >= 500)) {
                await new Promise(resolve => setTimeout(resolve, 1000));
                return attempt(retryCount + 1);
            }
            throw error;
        }
    }
    return attempt(0);
}

export const getApiUrlForRealm = (stage: string, realm: string): string =>
    `https://api-${stage.toLowerCase()}-${realm.toLowerCase()}.sherlock.payments.amazon.dev`;

export const makeAwsSignedRequest = (stage: string, realm: string, endpoint: string, options: any = {}): Promise<any> => {
    const baseUrl = getApiUrlForRealm(stage, realm);
    const url = `${baseUrl}/${endpoint.replace(/^\//, '')}`;
    const maxRetries = options.retry !== false ? 2 : 0;
    
    return getJSON(url, options, maxRetries);
};
